import tables from './tables';
import utils from '../utils';

const getTrackingDataById = async (id, token) => {
  try {
    const { data, success } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.tracking}/${id}`,
      token,
    );

    if (!success) throw new Error(data);

    return data;
  } catch (e) {
    throw `error getting tracking data by id ${e.message || e.responseText}`;
  }
};

const setTracking = async (data, token) => {
  try {
    const { id } = data;

    await utils.postToMikMakFirebaseService(`set/${tables.tracking}/${id}`, data, token);
  } catch (e) {
    throw `error setting tracking data ${e.message || e.responseText}`;
  }
};

export default {
  getTrackingDataById,
  setTracking,
};
